/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/js-cookie@2.2.1/src/js.cookie.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function t(o){function r(){}function i(n,t,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},r.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var c=JSON.stringify(t);/^[\{\[]/.test(c)&&(t=c)}catch(e){}t=o.write?o.write(t,n):encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var f="";for(var u in i)i[u]&&(f+="; "+u,!0!==i[u]&&(f+="="+i[u].split(";")[0]));return document.cookie=n+"="+t+f}}function c(e,t){if("undefined"!=typeof document){for(var r={},i=document.cookie?document.cookie.split("; "):[],c=0;c<i.length;c++){var f=i[c].split("="),u=f.slice(1).join("=");t||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var a=n(f[0]);if(u=(o.read||o)(u,a)||n(u),t)try{u=JSON.parse(u)}catch(e){}if(r[a]=u,e===a)break}catch(e){}}return e?r[e]:r}}return r.set=i,r.get=function(e){return c(e,!1)},r.getJSON=function(e){return c(e,!0)},r.remove=function(n,t){i(n,"",e(t,{expires:-1}))},r.defaults={},r.withConverter=t,r}(function(){})});
//# sourceMappingURL=/sm/b0ce608ffc029736e9ac80a8dd6a7db2da8e1d45d2dcfc92043deb2214aa30d8.map

function Georedirect(gAPIkey, config) {
  this.gAPIkey = gAPIkey
  this.siteConfig = config
  let _this = this

  init();

  function init() {
    let isGeoRedirected = getQuerystring("gr") !== ""
    let geoCountry = getQuerystring("gc")

    if (!window.georedirectEnabled) {
      return;
    }

    if (isGeoRedirected) {
      //Set cookie
      Cookies.set("isGeoRedirected", "true")
    }

    if (geoCountry !== "") {
      if (isFromEU(geoCountry) || isFromDK(geoCountry) || isFromUK(geoCountry) || isFromUS(geoCountry)) {
        var country = {
          short_name: geoCountry,
          long_name: shippingCountries[geoCountry].long_name
        }
        Cookies.set("userCountry", JSON.stringify(country));
        showCountry(country);
        return;
      }
    }

    geoLocate();
  }

  function getQuerystring(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
    var results = regex.exec(location.search)
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "))
  }

  function geoLocate() {
    if (Cookies.get("userCountry")) {
      var country = JSON.parse(Cookies.get("userCountry"));
      showCountry(country);
      handleRedirect(country);
      return
    } else if (Cookies.get('isGeoRedirected')) {
      showCountry();
      return;
    }

    // Set up our HTTP request
    var xhr = new XMLHttpRequest();

    // Setup our listener to process completed requests
    xhr.onload = function () {
      // Process our return data
      if (xhr.status >= 200 && xhr.status < 300) {
        // What do when the request is successful
        try {
          var retVal = JSON.parse(xhr.responseText)
          if (!retVal.geoname_id) {
            return
          }
            if (retVal.country_code2 === 'GB') {
              retVal.country_name = 'UK / England, Scotland & Wales';
          } else if (retVal.country_code2 === 'IE') {
            retVal.country_name = 'UK / Northern Ireland';
          }
          var country = {
            short_name: retVal.country_code2,
            long_name: retVal.country_name
          }

          Cookies.set("userCountry", JSON.stringify(country))
          showCountry(country)
          handleRedirect(country)
        } catch (e) {
          console.log(e);
        }
      } else {
        // What do when the request fails
        console.log('The request failed!');
      }
    };

    // Create and send a GET request
    xhr.open('GET', 'https://api.ipgeolocation.io/ipgeo?apiKey=' + _this.gAPIkey);
    xhr.send();
  }

  function handleRedirect(country) {
    if (Cookies.get('isGeoRedirected')) {
      return;
    }

    var countryCode = country.short_name
    var config = null
    if (isFromDK(countryCode)) {
      config = _this.siteConfig.fromDK
    } else if (isFromEU(countryCode)) {
      config = _this.siteConfig.fromEU
    } else if (isFromUK(countryCode)) {
      config = _this.siteConfig.fromUK
    } else if (isFromUS(countryCode)) {
      config = _this.siteConfig.fromUS
    } else {
      config = _this.siteConfig.fromRest
    }

    var origin = window.location.origin
    var shouldRedirect = !config.url.includes(origin)

    if (shouldRedirect) {
      if (_this.siteConfig.autoredirect) {
        var newUrl = window.location.href.replace(origin, config.url)
        var urlParameter = window.location.search ? '&gr=true' : '?gr=true'
        if (document.referrer && document.referrer.indexOf('nuori') == -1 && newUrl.indexOf('utm_referrer') == -1) {
          urlParameter += '&utm_referrer=' + document.referrer
        }
        newUrl += urlParameter
        window.top.location.replace(newUrl)
      } else if (!window.theme.isDesignMode) {
        updateGeoredirectPopup(country.long_name, config.url, config.short);
        showPopup('.region-selector-modal');
      }
    }
  }

  function updateGeoredirectPopup(country, url, countryCode) {
    let body = document.querySelector('.region-selector-modal .popup-body');
    let buttonHtml = ``;
    let redirectUrl;

    body.innerHTML = body.innerHTML.replace('{{country}}', country);
    redirectUrl = url + window.location.pathname + window.location.search;
    buttonHtml = `<a href="${redirectUrl}" id="redirect-button" class="Button Button--primary">VISIT ${countryCode} SHOP</a>`;

    body.innerHTML += buttonHtml;
  }

  function showCountry(country = null) {
    var $countrySelectors = document.querySelectorAll('.switch-site-container');
    $countrySelectors.forEach(function (cs) {
      var shippingText = 'Shipping to';
      var countryText = 'click here';
      if (null !== country) {
        try {
          var shippingCountry = shippingCountries[country.short_name];
          if (shippingCountry) {
            countryText = country.long_name;
            if (shippingCountry.currently_not_shipping) {
              shippingText = 'Currently not shipping to';
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
      cs.classList.add('show');
      cs.querySelector('.shipping-status').innerText = shippingText;
      cs.querySelector('.shipping-country').innerText = countryText;
    });
  }

  function isFromDK(countryCode) {
    return countryCode.toUpperCase() === "DK"
  }

  function isFromUK(countryCode) {
    gbCountries = {
      GB: "Great Britain",
      IE: "Ireland",
      CA: "Canada",
      AU: "Australia",
      NZ: "New Zealand",
      HK: "Hong Kong",
      CH: "Switzerland"
    }
    return gbCountries[countryCode.toUpperCase()] !== undefined
  }

  function isFromUS(countryCode) {
    return countryCode.toUpperCase() === "US"
  }

  function isFromEU(countryCode) {
    euCountries = {
      AT: "Austria",
      BE: "Belgium",
      BG: "Bulgaria",
      HR: "Croatia",
      CY: "Cyprus",
      CZ: "Czech Republic",
      DK: "Denmark",
      EE: "Estonia",
      FI: "Finland",
      FR: "France",
      DE: "Germany",
      GR: "Greece",
      HU: "Hungary",
      IE: "Ireland",
      IT: "Italy",
      LV: "Latvia",
      LT: "Lithuania",
      LU: "Luxembourg",
      MT: "Malta",
      NL: "Netherlands",
      NO: "Norway",
      PL: "Poland",
      PT: "Portugal",
      RO: "Romania",
      SK: "Slovakia",
      SI: "Slovenia",
      ES: "Spain",
      SE: "Sweden",
    }
    return euCountries[countryCode.toUpperCase()] !== undefined
  }
}

var Geo = new Georedirect("199419278f304cf5bab8b6ec92a1b043", {
  //Setup where to redirect users based on country of origin
  autoredirect: false,
  fromDK: {
    url: 'https://nuori.dk',
    short: 'DK'
  },
  fromEU: {
    url: 'https://nuori.com',
    short: 'EU'
  },
  fromUK: {
    url: 'https://nuori.co.uk',
    short: 'UK'
  },
  fromUS: {
    url: 'https://nuori.us',
    short: 'US'
  },
  fromRest: {
    url: 'https://nuori.com',
    short: 'EU'
  }
})